import { AiOutlineFileImage, AiOutlineFilePdf } from "react-icons/ai";
import i18n from "src/i18n";

import { documentFileTypes, imageFileTypes } from "@constants/fileTypes";


export const getFileTypeForDocumentation = (
  filenames: File[] | string[] | undefined
) => {
  if (!filenames || !filenames.length) return { text: [], node: <></> };

  const newFilenames = filenames as string[];
  // console.log(newFilenames);
  const isImageFileType = imageFileTypes.some(fileType =>
    newFilenames.some(filename => filename.toLowerCase().endsWith(fileType))
  );
  // console.log("is image:", isImageFileType, newFilenames.length);
  const isTextFileType = documentFileTypes.some(fileType =>
    newFilenames.some(filename => filename.toLowerCase().endsWith(fileType))
  );
  // console.log("is pdf:", isTextFileType, newFilenames.length);

  if (isImageFileType && isTextFileType && newFilenames.length > 1) {
    return {
      text: ["Image", "Report"],
      node: (
        <div
          className="file-type-icon-wrapper multiple-different"
          title={i18n.t("contains-docs-and-images")}>
          <div className="icon-wrapper image">
            <AiOutlineFileImage className="file-type-icon" />
          </div>
          <div className="icon-wrapper pdf">
            <AiOutlineFilePdf className="file-type-icon" />
          </div>
        </div>
      ),
    };
  }
  if (newFilenames.length > 1 && (isImageFileType || isTextFileType)) {
    return {
      text: [isImageFileType ? "Image" : "Report"],
      node: (
        <div
          className="file-type-icon-wrapper multiple-same"
          title={i18n.t(`contains-multiple-items`, {
            context: isImageFileType ? "image" : "doc",
          })}>
          {Array.from({ length: 2 }).map((_, index) => (
            <div
              className={`icon-wrapper ${isImageFileType ? "image" : "pdf"}`}
              key={index}>
              {isImageFileType ? (
                <AiOutlineFileImage className="file-type-icon" />
              ) : (
                <AiOutlineFilePdf className="file-type-icon" />
              )}
            </div>
          ))}
        </div>
      ),
    };
  }
  if (newFilenames.length === 1 && (isImageFileType || isTextFileType)) {
    return {
      text: [isImageFileType ? "Image" : "Report"],
      node: (
        <div
          className="file-type-icon-wrapper single"
          title={i18n.t(`contains-single-item`, {
            context: isImageFileType ? "image" : "doc",
          })}>
          <div className={`icon-wrapper ${isImageFileType ? "image" : "pdf"}`}>
            {isImageFileType ? (
              <AiOutlineFileImage className="file-type-icon" />
            ) : (
              <AiOutlineFilePdf className="file-type-icon" />
            )}
          </div>
        </div>
      ),
    };
  }

  return { text: [], node: <></> };
};
